import { Country } from '@/data';
import { useLanguage } from '@/contexts/AppContext';
import { CountrySelector } from './CountrySelector';

interface PhoneNumberInputProps {
  phoneNumber: string;
  onPhoneNumberChange: (value: string) => void;
  selectedCountry: Country;
  showCountryDropdown: boolean;
  onToggleCountryDropdown: () => void;
  countrySearch: string;
  onCountrySearchChange: (value: string) => void;
  filteredCountries: Country[];
  onSelectCountry: (country: Country) => void;
  onCloseCountryDropdown: () => void;
  getCountryName: (country: Country) => string;
}

/**
 * 전화번호 입력 컴포넌트
 * - 국가 선택 드롭다운
 * - 전화번호 입력 필드
 */
export function PhoneNumberInput({
  phoneNumber,
  onPhoneNumberChange,
  selectedCountry,
  showCountryDropdown,
  onToggleCountryDropdown,
  countrySearch,
  onCountrySearchChange,
  filteredCountries,
  onSelectCountry,
  onCloseCountryDropdown,
  getCountryName,
}: PhoneNumberInputProps) {
  const { language } = useLanguage();
  return (
    <div className="mb-[clamp(1rem,4vw,1.25rem)]">
      <label className="block text-[13px] font-medium text-foreground mb-2">
        {language === 'ko'
          ? '휴대폰 번호'
          : language === 'es'
            ? 'Número de teléfono'
            : 'Phone number'}
      </label>
      <div className="flex items-center border-2 border-border rounded-[5px] h-[50px] overflow-visible transition-all duration-200 focus-within:border-primary hover:border-primary/50">
        <CountrySelector
          selectedCountry={selectedCountry}
          showDropdown={showCountryDropdown}
          onToggleDropdown={onToggleCountryDropdown}
          countrySearch={countrySearch}
          onSearchChange={onCountrySearchChange}
          filteredCountries={filteredCountries}
          onSelectCountry={onSelectCountry}
          onCloseDropdown={onCloseCountryDropdown}
          getCountryName={getCountryName}
        />

        {/* Input Field */}
        <input
          type="tel"
          value={phoneNumber}
          onChange={(e) => onPhoneNumberChange(e.target.value)}
          placeholder={
            language === 'ko'
              ? '전화번호 입력'
              : language === 'es'
                ? 'Ingresa tu número'
                : 'Enter your number'
          }
          className="flex-1 min-w-0 px-4 bg-transparent text-foreground text-[15px] outline-none placeholder:text-muted-foreground overflow-hidden"
        />
      </div>
    </div>
  );
}
